import React from 'react';
import { Icons, SVG, SVGIcon } from '../../../../../components/atoms/SVG';
import { Badge, BadgeModifier } from '../../../../../_lib/components/Badge/index';

function IconContainer({ icon }: { icon: SVGIcon }) {
  return (
    <span className="pal-tab__iconcontainer">
      <SVG inverted svgSpriteId={icon} svgClass="pal-tab__icon" />
    </span>
  );
}

export function TabAnonymous() {
  return (
    <span className="pal-tab__icon-anonymous">
      <IconContainer icon={Icons.CLOSED_LOCK} />
    </span>
  );
}

export function TabWithIcon({ icon, badge }: { icon: SVGIcon; badge?: string | null }) {
  return (
    <>
      <IconContainer icon={icon} />
      {badge && (
        <Badge modifier={BadgeModifier.ALERT}>
          <span className="invisible">{badge}</span>
        </Badge>
      )}
    </>
  );
}
